import Swal from "sweetalert2";
import download from "downloadjs";
import { t } from "i18next";
import { const_routes } from "./const_routes";
import { fetchToken } from "./fetch";
import { resolveImportStageFromState } from "./importStageHelper";

const EXCEL_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const downloadImportResultFile = async ({
  parentRoute,
  endpoint,
  fullFilename,
  preFilename,
  termFilename,
  bagRowProcess,
  getState
}) => {
  const stage = resolveImportStageFromState(getState());
  const filename = stage === "pre" ? preFilename : (stage === "term" ? (termFilename || fullFilename) : fullFilename);

  try {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      parentRoute,
      endpoint,
      { bagRowProcess, stage },
      "POST"
    );

    if (!resp.ok) {
      Swal.fire(t("titles.error"), "Error en descarga de archivo", "error");
      return;
    }

    const blob = await resp.blob();
    if (!blob) {
      Swal.fire(t("titles.error"), "Error en descarga de archivo", "error");
      return;
    }

    download(blob, filename, EXCEL_MIME);
  } catch (error) {
    Swal.fire(t("titles.error"), "Error en descarga de archivo", "error");
  }
};

export const downloadImportExampleFile = async ({
  parentRoute,
  endpoint,
  fullFilename,
  preFilename,
  termFilename,
  getState
}) => {
  const stage = resolveImportStageFromState(getState());
  const filename = stage === "pre" ? preFilename : (stage === "term" ? (termFilename || fullFilename) : fullFilename);

  try {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      parentRoute,
      `${endpoint}?stage=${encodeURIComponent(stage)}`,
      undefined,
      "GET"
    );

    if (!resp.ok) {
      Swal.fire(t("titles.error"), "Error en descarga de archivo", "error");
      return;
    }

    const blob = await resp.blob();
    if (!blob) {
      Swal.fire(t("titles.error"), "Error en descarga de archivo", "error");
      return;
    }

    download(blob, filename, EXCEL_MIME);
  } catch (error) {
    Swal.fire(t("titles.error"), "Error en descarga de archivo", "error");
  }
};
